<template>
	<div class="container-fluid">
		<b-overlay
			:show="loading"
			rounded="sm"
		>
			<h1 class="border-bottom d-flex mb-5">
				<span class="mr-auto">Measurements</span>
				<button
					class="btn btn-link"
					@click="fetchRecords"
				>
					<b-icon icon="arrow-repeat"></b-icon>
				</button>
				<button
					class="btn btn-link"
					v-b-toggle.filters
				>
					<b-icon icon="filter"></b-icon>
					<span
						class="badge badge-primary ml-2"
						v-if="conditionCount"
					>{{ conditionCount }}</span>
				</button>
				<button
					class="btn btn-link"
					:disabled="skip <= 0"
				>
					<b-icon
						icon="chevron-left"
						@click="skip -= limit"
					></b-icon>
				</button>
				<button
					class="btn bnt-link"
					disabled
				>
					{{ skip + 1}} - {{ Math.min(skip + limit, count) }} / {{ count }}
				</button>
				<button
					class="btn btn-link"
					@click="skip += limit"
					:disabled="skip + limit >= count"
				>
					<b-icon icon="chevron-right"></b-icon>
				</button>
				<input
					min="0"
					max="999"
					step="1"
					type="Number"
					style="fontSize: medium"
					v-model.number="reqlimit"
				/>
			</h1>

			<b-collapse
				id="filters"
				class="mx-auto col-lg-10 col-xl-8 px-0"
			>
				<FilterBox
					:fields="MEASUREMENT_LISTED_FIELDS_FLAT_FILTER"
					@update="updateFilter"
				/>
			</b-collapse>

			<div
				class="horizontal-scroll mb-3"
				v-if="records.length"
			>
				<table class="mb-0 table table-bordered table-hover table-striped table-sm">
					<thead>
            <tr>
              <th>#</th>
							<th
								class="cursor-pointer text-nowrap"
								v-for="f in selectedFieldsFlat"
								:key="f.field"
								@click="toggleSort(f.field)"
							>
								{{ f.label }}
								<b-icon
									icon="arrow-down-short"
									v-if="settings.measurementsSortFields[f.field] === -1"
								></b-icon>
								<b-icon
									icon="arrow-up-short"
									v-if="settings.measurementsSortFields[f.field] === 1"
								></b-icon>
							</th>
							<th class="bg-light position-sticky right-0">
								<button
									class="btn btn-link"
									v-b-modal.settings
								>
									<b-icon icon="gear"></b-icon>
								</button>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(record,index) in records"
							:key="record._id"
            >
              <td> {{index+skip+1}} </td>
							<td
								class="text-nowrap"
								v-for="f in selectedFieldsFlat"
								:key="f.field"
							>
								{{ formatForList(readFieldFlat(record, f.field), f) }}
							</td>
							<td class="bg-light position-sticky right-0">
								<router-link
									class="btn btn-link"
									:to="'/measurement/' + record._id"
								>
									<b-icon icon="eye"></b-icon>
								</router-link>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else>
				<p class="font-italic text-center">No matching records found.</p>
			</div>
		</b-overlay>

		<b-modal
			centered
			hide-footer
			hide-header-close
			id="settings"
			size="xl"
			title="Measurement fields to be shown"
			@hide="storeSettings"
		>
			<ul class="list-unstyled row">
				<li
					class="col-sm-6 col-md-4 col-lg-3 mb-2"
					v-for="f in MEASUREMENT_LISTED_FIELDS_FLAT"
					:key="f.field"
				>
					<div class="form-check">
						<input
							class="form-check-input"
							:id="'measurement-field-chk-' + f.field"
							type="checkbox"
							:value="f.field"
							v-model="settings.measurementsSelectedFields"
						> <label
							class="form-check-label"
							:for="'measurement-field-chk-' + f.field"
						>{{ f.label }}</label>
					</div>
				</li>
			</ul>
		</b-modal>
	</div>
</template>

<script>
import apiClient from '../apiClient'
import { MEASUREMENT_LISTED_FIELDS_FLAT } from '@/fields/measurement_fields'
import { formatForList, readFieldFlat } from '@/util'
import FilterBox from '@/components/FilterBox'

export default {
	components: { FilterBox },
	data() {
		return {
			MEASUREMENT_LISTED_FIELDS_FLAT,
			conditionCount: 0,
			find: {},
			reqlimit: 20,
			loading: false,
			records: [],
			settings: {},
			skip: 0,
			count: 0,
		}
	},
	computed: {
		MEASUREMENT_LISTED_FIELDS_FLAT_FILTER() {
			var retval = this.MEASUREMENT_LISTED_FIELDS_FLAT
			Object.entries(retval).forEach(([index, value]) => {
				if (value.field === 'tags') {
					retval[index].type = 'enum'
				}
			})
			return retval
		},
		limit() {
			return this.reqlimit === 0 ? this.count : this.reqlimit
		},
		dbGetReqBody() {
			const { find, reqlimit, skip } = this
			const sort = this.settings.measurementsSortFields
			return {
				humanize: true,
				populateAnimal: true,
				find,
				limit: reqlimit,
				skip,
				sort,
			}
		},
		selectedFieldsFlat() {
			return MEASUREMENT_LISTED_FIELDS_FLAT.filter((f) =>
				(this.settings.measurementsSelectedFields || []).includes(
					f.field
				)
			)
			// below approach can retain saved order of fields too:
			/*return (this.settings.measurementsSelectedFields || [])
				.map(
					(sf) =>
						MEASUREMENT_LISTED_FIELDS_FLAT.filter(
							(f) => f.field === sf
						)[0]
				)
				.filter((f) => f)*/
		},
	},
	methods: {
		formatForList,
		readFieldFlat,
		async fetchRecords() {
			this.loading = true
			const { matchedCount, records } = await apiClient.measurementFind(
				this.dbGetReqBody
			)
			this.records = records
			this.count = matchedCount
			this.loading = false
		},
		async fetchSettings() {
			this.settings = await apiClient.userSettings()
		},
		storeSettings() {
			apiClient.userSettings(this.settings)
		},
		toggleSort(field) {
			const s = {}
			s[field] = this.settings.measurementsSortFields[field] || -1
			s[field] *= -1
			this.settings.measurementsSortFields = s
			this.storeSettings()
			this.fetchRecords()
		},
		updateFilter(find, conditionCount) {
			this.find = find
			this.conditionCount = conditionCount
			this.fetchRecords()
		}
	},
	watch: {
		skip() {
			this.fetchRecords()
		},
		reqlimit() {
			this.skip = 0
			this.fetchRecords()
		}
	},
	async mounted() {
		await this.fetchSettings()
		this.fetchRecords()
	},
}
</script>
